import { literal, number, string, struct } from 'io-ts/lib/Decoder';

/**
 * Sent when a measurement on a frame is updated.
 */
export const MeasurementUpdated = struct({
	type: literal('measurement-updated'),
	frameId: string,
	measurement: number,
});
